import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login1.css';
import Yellow1 from '../../assets/images/components/Yellow1.png';
import Yellow2 from '../../assets/images/components/Yellow2.png';
import Yellow3 from '../../assets/images/components/Yellow3.png';
import Yellow4 from '../../assets/images/components/Yellow4.png';
import Yellow5 from '../../assets/images/components/Yellow5.png';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

// const Logo = styled.div`
//     position: fixed;
//     top: 15vh;
//     // right: 0;
//     font-size: 16px;
//     font-weight: 500;
//     color: white;
//     letter-spacing: 1px;
//     cursor: pointer;
// `;

const BookingsApp = () => {
    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState(null);

    // Array of all possible images
    const images = [
        Yellow1,
        Yellow2,
        Yellow3,
        Yellow4,
        Yellow5
    ];

    useEffect(() => {
        // Get the last displayed image path from localStorage
        const lastImage = localStorage.getItem('lastDisplayedImage');

        // Select a random image that's different from the last one
        let randomIndex;
        let newImage;

        do {
            randomIndex = Math.floor(Math.random() * images.length);
            newImage = images[randomIndex];
        } while (newImage === lastImage && images.length > 1);

        // Save the new image to localStorage for next time
        localStorage.setItem('lastDisplayedImage', newImage);

        // Set the selected image
        setSelectedImage(newImage);
    }, []);

    // Add useEffect for scroll prevention
    useEffect(() => {
        // More comprehensive scroll prevention
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
        document.body.style.touchAction = 'none'; // Prevent touch scrolling

        return () => {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = 'unset';
            document.body.style.position = 'static';
            document.body.style.width = 'auto';
            document.body.style.height = 'auto';
            document.body.style.touchAction = 'auto';
        };
    }, []);

    const handleLoginWithAgency = () => {
        navigate('/bookings/login-agency');
    }

    const handleBulkImport = () => {
        navigate('/bookings/bulk-import');
    }

    const handleManualAdd = () => {
        navigate('/bookings/manual-add');
    }

    return (
        <div className="bookings-login-container">
            <div className="bookings-mobile-frame">
                {/* Home button positioned at top right for mobile */}
                <div className="bookings-home-button-container">
                    <span onClick={() => navigate('/')}
                        className='bookings-home-button'>HOME</span>
                </div>
                <div className="bookings-login-content">
                    <div className="bookings-login-image-wrapper">
                        <div className="bookings-image-container">
                            {selectedImage && (
                                <img
                                    src={selectedImage}
                                    alt="AI Art"
                                    className="bookings-login-image"
                                />
                            )}
                            <div className="bookings-image-gradient"></div>
                        </div>
                        <div className="bookings-login-branding">
                            <p className="uppercase tracking-[3px] font-medium">B O O K I N G</p>
                        </div>
                    </div>
                    <div className="bookings-login-buttons !bottom-[-5px]">
                        <button
                            className="bookings-login-button reduced-height opacity-40 cursor-not-allowed"
                            title="Coming soon"
                        >
                            Login with agency
                        </button>
                        <button
                            className="bookings-login-button reduced-height"
                            onClick={handleBulkImport}
                        >
                            Import
                        </button>
                        <button
                            className="bookings-login-button reduced-height"
                            onClick={() => navigate('/bookings/view-all')}
                        >
                            View all
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookingsApp; 